import React, { FunctionComponent, useContext, useEffect } from 'react'
import { css } from '@emotion/react'
import { Layout } from 'antd'
import { backgroundColor } from '../../../theme'
import DevicesList from '../../DevicesList/DevicesList'
import { MapSettingsContext } from '../../../contexts/MapSettingsContext'
import MapSettingsContextInterface from '../../../contexts/MapSettingsContext/MapSettingsContextInterface'
import VehicleLocationHistoryList from '../../VehicleLocationHistoryList/VehicleLocationHistoryList'
import Collections from '../../Collections/Collections'
import { AuthContext } from '@strac/react-client-auth'
import Geofences from '../../Geofences/Geofences'
import Directions from '../../Map/SearchBar/Directions/Directions'

const { Sider } = Layout

interface IProps {
  selectedKey: string | undefined
  setSelectedKey: (key: string) => void
}

const LeftSider: FunctionComponent<any> = (props: IProps) => {

  const { selectedKey, setSelectedKey } = props

  const { selectedVehicleHistory } = useContext(MapSettingsContext) as MapSettingsContextInterface

  const { authUser } = useContext(AuthContext) as any

  useEffect(() => {
    if (selectedVehicleHistory) {
      setSelectedKey('vehicle-history')
    }
  }, [selectedVehicleHistory, setSelectedKey])

  const routes = {
    'devices': <DevicesList userId={authUser.id} />,
    'collections': <Collections userId={authUser.id} />,
    'vehicle-history': <VehicleLocationHistoryList vehicleId={selectedVehicleHistory} />,
    'geofences': <Geofences userId={authUser.id} />,
    'directions': <Directions />
  }

  const collapsed = selectedKey ? !Object.keys(routes).includes(selectedKey) : true

  return (
    <Sider
      css={css`
        background-color: ${backgroundColor} !important;
        height: 100vh;
        position: relative;
        overflow: auto;
      `}
      trigger={null}
      collapsible={true}
      collapsed={collapsed}
      collapsedWidth={0}
      width={400}
    >
      {selectedKey ? routes[selectedKey] : null}
    </Sider>
  )
}

export default LeftSider
